import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Onboarding from "./pages/Onboarding";
import SimpleWizard from "./pages/SimpleWizard";
import Dashboard from "./pages/Dashboard";
import BrandAnalysis from "./pages/BrandAnalysis";
import Campaigns from "./pages/Campaigns";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";
import BuyTokens from "./pages/BuyTokens";
import ConnectMeta from "./pages/ConnectMeta";
import ConnectUnified from "./pages/ConnectUnified";
import MetaSetupGuide from "./pages/MetaSetupGuide";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import DevPanel from "./pages/DevPanel";
import Conversions from "./pages/Conversions";
// Refactor — territorial acquisition core
import AuthLogin from "./pages/AuthLogin";
import Personas from "./pages/Personas";
import Locais from "./pages/Locais";
import Zonas from "./pages/Zonas";
import Campanhas from "./pages/Campanhas";
import Performance from "./pages/Performance";
import CoreDashboard from "./pages/CoreDashboard";
import Configuracoes from "./pages/Configuracoes";
import { isAuthed } from "./lib/api";

// Gate: redirect to /login when no JWT.
function Protected({ children }) {
  return isAuthed() ? children : <AuthLogin />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<AuthLogin />} />

          {/* Territorial-acquisition core (refactor) — dedicated views */}
          <Route path="/dashboard" element={<Protected><CoreDashboard /></Protected>} />
          <Route path="/personas" element={<Protected><Personas /></Protected>} />
          <Route path="/locais" element={<Protected><Locais /></Protected>} />
          <Route path="/zonas" element={<Protected><Zonas /></Protected>} />
          <Route path="/campanhas" element={<Protected><Campanhas /></Protected>} />
          <Route path="/performance" element={<Protected><Performance /></Protected>} />
          <Route path="/configuracoes" element={<Protected><Configuracoes /></Protected>} />

          <Route path="/dev" element={<DevPanel />} />
          <Route path="/wizard" element={<SimpleWizard />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/dashboard/:clientId" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/brand/:brandId" element={<BrandAnalysis />} />
          <Route path="/campaigns/:clientId" element={<Campaigns />} />
          <Route path="/conversions/:clientId" element={<Conversions />} />
          <Route path="/settings/:clientId" element={<Settings />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/buy-tokens/:clientId" element={<BuyTokens />} />
          <Route path="/connect-meta/:clientId" element={<ConnectMeta />} />
          <Route path="/connect-unified/:clientId" element={<ConnectUnified />} />
          <Route path="/meta-setup-guide" element={<MetaSetupGuide />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
